(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gloura-b2b"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = (root) => {
    if (root.dataset.b2bInitialized === 'true') return;
    root.dataset.b2bInitialized = 'true';
    const buttons = [...root.querySelectorAll('[data-sector-button]')];
    const panels = [...root.querySelectorAll('[data-sector-panel]')];
    const showSector = (key) => {
      buttons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.sectorButton === key)));
      panels.forEach((panel) => { panel.hidden = panel.dataset.sectorPanel !== key; });
    };
    buttons.forEach((button) => button.addEventListener('click', () => showSector(button.dataset.sectorButton)));
    root.querySelectorAll('[data-sector-cta]').forEach((link) => link.addEventListener('click', () => {
      const select = root.querySelector('[data-industry-select]');
      const option = select?.querySelector('[data-sector-option="' + link.dataset.sectorCta + '"]');
      if (select && option) {
        select.value = option.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }));
    showSector('cafe');
    root.classList.add('is-enhanced');
    const result = root.querySelector('[data-form-result]');
    if (result) result.focus({ preventScroll: true });
  };
  const initializeWithin = (scope) => {
    if (scope.matches?.('[data-gloura-b2b]')) initialize(scope);
    scope.querySelectorAll('[data-gloura-b2b]').forEach(initialize);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeWithin(document), { once: true });
  } else {
    initializeWithin(document);
  }
  document.addEventListener('shopify:section:load', (event) => initializeWithin(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gloura-bar-password"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gloura-bar-password')) {
    customElements.define('gloura-bar-password', class extends HTMLElement {
      connectedCallback() {
        this.earlyAt = Date.parse(this.dataset.earlyAt);
        this.publicAt = Date.parse(this.dataset.publicAt);
        this.copy = JSON.parse(this.querySelector('[data-countdown-copy]').textContent);
        this.tick();
        this.timer = window.setInterval(() => this.tick(), 1000);
        this.querySelector('.gbp-header-link').addEventListener('click', () => {
          this.querySelector('.gbp-access').open = true;
          this.querySelector('input[name="password"]').focus({ preventScroll: true });
        });
      }
      disconnectedCallback() { window.clearInterval(this.timer); }
      tick(now = Date.now()) {
        const phase = now < this.earlyAt ? 'waiting' : now < this.publicAt ? 'early' : 'public';
        const launchDayStart = Date.parse('2026-10-03T00:00:00+02:00');
        const headline = now >= this.publicAt ? this.copy.headlineLaunch : now >= launchDayStart ? this.copy.headlineToday : this.copy.headlineTomorrow;
        const headlineElement = this.querySelector('[data-launch-headline]');
        if (headlineElement.textContent !== headline) headlineElement.textContent = headline;
        const deadline = phase === 'waiting' ? this.earlyAt : this.publicAt;
        const seconds = Math.max(0, Math.ceil((deadline - now) / 1000));
        const values = { days: Math.floor(seconds / 86400), hours: Math.floor(seconds / 3600) % 24, minutes: Math.floor(seconds / 60) % 60, seconds: seconds % 60 };
        Object.entries(values).forEach(([unit, value]) => { this.querySelector(`[data-${unit}]`).textContent = String(value).padStart(2, '0'); });
        if (phase !== this.phase) {
          const label = this.querySelector('[data-countdown-label]');
          const clock = this.querySelector('[data-clock]');
          const status = this.querySelector('[data-phase-status]');
          label.textContent = phase === 'waiting' ? this.copy.earlyLabel : this.copy.publicLabel;
          clock.setAttribute('aria-label', label.textContent);
          clock.hidden = phase === 'public';
          label.hidden = phase === 'public';
          status.hidden = phase === 'waiting';
          status.textContent = phase === 'early' ? this.copy.earlyOpen : phase === 'public' ? this.copy.publicOpen : '';
          this.phase = phase;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gloura-bar-teaser"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gloura-bar-teaser')) {
  customElements.define('gloura-bar-teaser', class extends HTMLElement {
    static initializedFrames = new WeakSet();
    static loadHostedResizer(src) {
      if (typeof window.iFrameResize === 'function') return Promise.resolve();
      if (!this.resizerPromise) {
        this.resizerPromise = new Promise((resolve, reject) => {
          let script = document.querySelector('script[src="' + src + '"]');
          const isNew = !script;
          if (isNew) {
            script = document.createElement('script');
            script.src = src;
            script.async = true;
          }
          let timeout;
          const finish = error => {
            window.clearTimeout(timeout);
            script.removeEventListener('load', loaded);
            script.removeEventListener('error', failed);
            if (error) reject(error); else resolve();
          };
          const loaded = () => finish(typeof window.iFrameResize === 'function' ? null : new Error('Resizer global function missing'));
          const failed = () => finish(new Error('Resizer script failed to load'));
          script.addEventListener('load', loaded, {once: true});
          script.addEventListener('error', failed, {once: true});
          timeout = window.setTimeout(() => finish(new Error('Resizer script load timed out')), 12000);
          if (isNew) document.head.appendChild(script);
        });
      }
      return this.resizerPromise;
    }
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.deadline = Date.parse(this.dataset.launchAt);
      this.tick = this.tick.bind(this);
      this.tick();
      if (Number.isFinite(this.deadline) && this.deadline > Date.now()) this.timer = window.setInterval(this.tick, 1000);
      this.sectionHost = this.closest('.shopify-section') || this;
      this.sectionUnload = () => this.disconnectedCallback();
      this.sectionHost.addEventListener('shopify:section:unload', this.sectionUnload);
      this.hostedFrame = this.querySelector('[data-hosted-signup]');
      this.connectionToken = {};
      if (this.hostedFrame) this.initHostedFrame(this.connectionToken);

    }
    disconnectedCallback() {
      window.clearInterval(this.timer);
      window.clearTimeout(this.resizeHandshakeTimer);
      if (this.sectionHost && this.sectionUnload) this.sectionHost.removeEventListener('shopify:section:unload', this.sectionUnload);
      this.connectionToken = null;
      this.ready = false;
    }
    async initHostedFrame(token) {
      const frame = this.hostedFrame;
      if (this.constructor.initializedFrames.has(frame)) return;
      frame.dataset.resizeState = 'loading';
      try {
        await this.constructor.loadHostedResizer(this.dataset.resizerSrc);
        if (!this.isConnected || this.connectionToken !== token || !frame.isConnected) return;
        window.iFrameResize({scrolling: true, checkOrigin: true, heightCalculationMethod: 'bodyScroll', resizedCallback: data => {
          if (data.iframe) {
            if (data.iframe === frame) window.clearTimeout(this.resizeHandshakeTimer);
            data.iframe.dataset.resizeState = 'active';
            data.iframe.dataset.resizeHeight = data.height;
          }
        }}, frame);
        if (frame.dataset.resizeState !== 'active') {
          frame.dataset.resizeState = 'initialized';
          this.resizeHandshakeTimer = window.setTimeout(() => {
            if (this.connectionToken !== token || frame.dataset.resizeState === 'active') return;
            frame.dataset.resizeState = 'fallback';
            frame.dataset.resizeError = 'Hosted page resize handshake unavailable';
            frame.scrolling = 'yes';
            frame.style.height = '';
          }, 4000);
        }
        this.constructor.initializedFrames.add(frame);
      } catch (error) {
        if (this.connectionToken !== token) return;
        frame.dataset.resizeState = 'fallback';
        frame.dataset.resizeError = error.message;
        frame.scrolling = 'yes';
        frame.style.height = '';
      }
    }
    tick() {
      if (!Number.isFinite(this.deadline)) return;
      const remaining = Math.max(0, Math.floor((this.deadline - Date.now()) / 1000));
      this.querySelector('[data-countdown]').hidden = false;
      const values = {days: Math.floor(remaining / 86400), hours: Math.floor(remaining / 3600) % 24, minutes: Math.floor(remaining / 60) % 60, seconds: remaining % 60};
      for (const [unit, value] of Object.entries(values)) this.querySelector('[data-' + unit + ']').textContent = String(value).padStart(2, '0');
      if (Date.now() >= this.deadline) {
        window.clearInterval(this.timer);
        this.querySelector('[data-before-launch]').hidden = true;
        this.querySelector('[data-after-launch]').hidden = false;
        const cta = this.querySelector('[data-bottom-cta]');
        const target = this.querySelector('[data-after-launch] a');
        cta.href = target.href;
        cta.textContent = target.textContent;
      }
    }

  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gloura-collection"] && !Shopify.designMode) return;
  try {
    
(()=>{
    function initCompactHeader(header){
      if(header.dataset.gscInit)return;
      header.dataset.gscInit='true';
      const root=header.closest('[data-glc-root]');
      if(!root)return;
      const update=()=>{
        /* New gloura-navigation: sticky section + absolute top rail + bottom product rail.
           Measure the live bottom edge of that stack so the countdown sticks below it. */
        const section=document.querySelector('.gloura-header-section');
        const rail=document.querySelector('[data-gh-rail]');
        const ghHeader=document.querySelector('.gh-header');
        let bottom=0;
        if(rail&&getComputedStyle(rail).display!=='none'&&rail.getBoundingClientRect().height>0){
          bottom=rail.getBoundingClientRect().bottom;
        }else if(ghHeader){
          bottom=ghHeader.getBoundingClientRect().bottom;
        }else if(section){
          const style=getComputedStyle(section);
          const mb=Math.max(0,parseFloat(style.marginBottom)||0);
          bottom=section.getBoundingClientRect().bottom+mb;
        }
        const offset=Math.max(0,Math.ceil(bottom));
        root.style.setProperty('--gsc-nav-offset',offset+'px');
      };
      const observer=typeof ResizeObserver==='function'?new ResizeObserver(update):null;
      const section=document.querySelector('.gloura-header-section');
      if(observer&&section)observer.observe(section);
      const rail=document.querySelector('[data-gh-rail]');
      if(observer&&rail)observer.observe(rail);
      window.addEventListener('resize',update,{passive:true});
      window.addEventListener('scroll',update,{passive:true});
      const unload=event=>{
        if(event.target.contains(header)){
          if(observer)observer.disconnect();
          window.removeEventListener('resize',update);
          window.removeEventListener('scroll',update);
          document.removeEventListener('shopify:section:unload',unload);
        }
      };
      document.addEventListener('shopify:section:unload',unload);
      update();
    }
    const init=()=>document.querySelectorAll('[data-gsc-header]').forEach(initCompactHeader);
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
    document.addEventListener('shopify:section:load',init);
  })();
(function(){
  function initGloura(root){
  if(!root||root.dataset.glcInit)return;
  root.dataset.glcInit='1';
  var ajaxOn=root.dataset.ajaxAdd==='true';
  var cartUrl=root.dataset.cartUrl||'/cart';
  var cartAddUrl=root.dataset.cartAddUrl||'/cart/add';
  var secretSalePromoSuppressed=false;
  try{secretSalePromoSuppressed=Boolean(sessionStorage.getItem('gloura:promo-user-override'));}catch(_e){}
  function syncSecretSaleActivation(promo){
    var status=root.querySelector('[data-glc-ss-activation]');
    if(!status)return;
    promo=promo||window.glouraPromoActivation;
    var active=promo&&promo.validation!=='rejected'&&!secretSalePromoSuppressed&&!promo.userOverride&&['activated','applied','stored','multiple'].indexOf(promo.state)!==-1;
    var code=active?String(promo.code||'').trim():'';
    var label=status.querySelector('[data-glc-ss-activation-text]');
    var heading=root.querySelector('[data-glc-ss-heading]');
    if(heading&&promo){
      var gate=document.querySelector('[data-gss-root]');
      var normalized=code.toUpperCase();
      var mapped=gate&&gate.__gssInstance&&gate.__gssInstance.lookupInfluencer(normalized);
      var percent=mapped&&mapped.active!==false&&mapped.percent>0?mapped.percent:0;
      if(!percent)percent=Number(heading.dataset.offerPercent)||0;
      var offerText=active&&percent>0?heading.dataset.offerTitle.replace('__PERCENT__',String(percent)):'';
      var blackGlow=heading.dataset.ssMode==='black_glow';
      var offerLine=root.querySelector('[data-glc-ss-offer-line]');
      heading.textContent=blackGlow||!offerText?heading.dataset.offerFallback:offerText;
      if(offerLine)offerLine.textContent=blackGlow?offerText:'';
      var normalize=function(value){return String(value||'').replace(/\s+/g,' ').trim().toLowerCase();};
      var eyebrow=root.querySelector('[data-glc-ss-eyebrow]');
      var titleLabel=normalize(heading.textContent);
      var eyebrowLabel=eyebrow?normalize(eyebrow.getAttribute('data-label')):'';
      var offerLabel=offerLine?normalize(offerLine.textContent):'';
      if(eyebrow)eyebrow.hidden=!eyebrowLabel||eyebrowLabel===titleLabel||(!!offerLabel&&eyebrowLabel===offerLabel);
      if(offerLine)offerLine.hidden=!offerLabel||offerLabel===titleLabel||(!!eyebrowLabel&&offerLabel===eyebrowLabel);
    }
    if(!active||!code||promo.validation==='rejected'){
      status.hidden=true;
      if(label)label.textContent='';
      return;
    }
    if(label)label.textContent=promo.state==='multiple'?status.dataset.multipleText:status.dataset.activeText.replace('__CODE__',code);
    status.hidden=false;
  }
  if(root.querySelector('[data-glc-ss-activation]')){
    var removeSecretSaleListeners=function(){
      document.removeEventListener('gloura:promo-state',onSecretSalePromo);
      document.removeEventListener('gloura:promo-user-override',onSecretSaleOverride);
    };
    var onSecretSalePromo=function(event){
      if(!root.isConnected){removeSecretSaleListeners();return;}
      secretSalePromoSuppressed=Boolean(event.detail&&event.detail.userOverride);
      syncSecretSaleActivation(event.detail);
    };
    var onSecretSaleOverride=function(){
      if(!root.isConnected){removeSecretSaleListeners();return;}
      secretSalePromoSuppressed=true;
      syncSecretSaleActivation();
    };
    document.addEventListener('gloura:promo-state',onSecretSalePromo);
    document.addEventListener('gloura:promo-user-override',onSecretSaleOverride);
    syncSecretSaleActivation();
  }
  function updateVariantCard(input,immediate){
    if(!input||!input.checked)return;
    var card=input.closest?input.closest('.glc-card'):null;
    if(!card)return;
    var url=input.dataset.glcUrl||'';
    if(url){
      var links=card.querySelectorAll('.glc-imglink, .glc-slide, .glc-cinfo h3 a, .glc-quick-link, .glc-notify');
      for(var li=0;li<links.length;li++){links[li].setAttribute('href',url);}
    }
    var price=card.querySelector('[data-glc-price]');
    if(price&&input.dataset.glcPrice){price.textContent=input.dataset.glcPrice;}
    var campaignPrice=card.querySelector('[data-glc-campaign-price]');
    if(campaignPrice&&input.dataset.glcCampaignPrice){campaignPrice.textContent=input.dataset.glcCampaignPrice;}
    var shopMoney=card.querySelector('[data-glc-shop-money]');
    if(shopMoney&&input.dataset.glcShopMoney){shopMoney.textContent=input.dataset.glcShopMoney;}
    var compare=card.querySelector('[data-glc-compare]');
    if(compare){
      if(input.dataset.glcCompare){compare.textContent=input.dataset.glcCompare;compare.removeAttribute('hidden');}
      else{compare.textContent='';compare.setAttribute('hidden','');}
    }
    var unit=card.querySelector('[data-glc-unit]');
    if(unit){
      if(input.dataset.glcUnit){unit.textContent=input.dataset.glcUnit;unit.removeAttribute('hidden');}
      else{unit.textContent='';unit.setAttribute('hidden','');}
    }
    var galleryDefault=input.dataset.glcGalleryDefault==='true';
    var slides=card.querySelectorAll('.glc-slide');
    for(var si=1;si<slides.length;si++){slides[si].style.display=galleryDefault?'':'none';}
    var dots=card.querySelector('.glc-sdots');
    if(dots){dots.style.display=galleryDefault?'':'none';}
    var slider=card.querySelector('[data-glc-slider]');
    if(slider){
      slider.scrollLeft=0;
      if(typeof slider._glcSync==='function'){slider._glcSync();}
    }
    var img=card.querySelector('.glc-slide:first-child img, .glc-img1');
    var src=input.dataset.glcImage||'';
    if(!img||!src)return;
    var srcset=input.dataset.glcSrcset||'';
    var token=String(input.value)+'-'+String(Date.now())+'-'+String(Math.random());
    card.dataset.glcVariantToken=token;
    function applyImage(){
      if(card.dataset.glcVariantToken!==token)return;
      if(srcset){img.setAttribute('srcset',srcset);}else{img.removeAttribute('srcset');}
      img.setAttribute('src',src);
      if(input.dataset.glcImageWidth){img.setAttribute('width',input.dataset.glcImageWidth);}
      if(input.dataset.glcImageHeight){img.setAttribute('height',input.dataset.glcImageHeight);}
      img.setAttribute('alt',input.dataset.glcAlt||'');
    }
    if(immediate){applyImage();return;}
    var probe=new Image();
    var sizes=img.getAttribute('sizes');
    if(sizes){probe.sizes=sizes;}
    if(srcset){probe.srcset=srcset;}
    probe.onload=applyImage;
    probe.onerror=applyImage;
    probe.src=src;
  }
  function syncVariantCards(){
    var selected=root.querySelectorAll('.glc-vdots input[type="radio"][name="id"]:checked');
    for(var vi=0;vi<selected.length;vi++){updateVariantCard(selected[vi],true);}
  }
  function setSecretSaleOfferOpen(offer,open){
    if(!offer)return;
    var btn=offer.querySelector('[data-glc-ss-offer-btn]');
    var panel=offer.querySelector('[data-glc-ss-offer-panel]');
    if(!btn||!panel)return;
    btn.setAttribute('aria-expanded',open?'true':'false');
    if(open){
      panel.classList.add('is-open');
      panel.removeAttribute('hidden');
      positionSecretSaleOfferPanel(offer);
    }else{
      panel.classList.remove('is-open');
      panel.setAttribute('hidden','');
      panel.style.left='';
      panel.style.right='';
      panel.style.top='';
      panel.style.bottom='';
    }
  }
  function positionSecretSaleOfferPanel(offer){
    var panel=offer.querySelector('[data-glc-ss-offer-panel]');
    if(!panel||!panel.classList.contains('is-open'))return;
    var pad=12;
    panel.style.left='auto';
    panel.style.right='0px';
    panel.style.top='calc(100% + 8px)';
    panel.style.bottom='auto';
    var rect=panel.getBoundingClientRect();
    var vw=window.innerWidth||document.documentElement.clientWidth||0;
    var vh=window.innerHeight||document.documentElement.clientHeight||0;
    if(rect.right>vw-pad){
      panel.style.right=((rect.right-(vw-pad)))+'px';
      rect=panel.getBoundingClientRect();
    }
    if(rect.left<pad){
      panel.style.right='auto';
      panel.style.left='0px';
      rect=panel.getBoundingClientRect();
      if(rect.right>vw-pad){
        panel.style.left=((pad-rect.left)+(parseFloat(panel.style.left)||0))+'px';
        rect=panel.getBoundingClientRect();
      }
    }
    if(rect.bottom>vh-pad){
      panel.style.top='auto';
      panel.style.bottom='calc(100% + 8px)';
      rect=panel.getBoundingClientRect();
      if(rect.top<pad){
        panel.style.bottom='auto';
        panel.style.top='calc(100% + 8px)';
      }
    }
  }
  function initSecretSaleOffers(){
    var offers=root.querySelectorAll('[data-glc-ss-offer]');
    if(!offers.length)return;
    for(var oi=0;oi<offers.length;oi++){
      (function(offer){
        var btn=offer.querySelector('[data-glc-ss-offer-btn]');
        if(!btn)return;
        btn.addEventListener('click',function(e){
          e.preventDefault();
          e.stopPropagation();
          var willOpen=btn.getAttribute('aria-expanded')!=='true';
          for(var j=0;j<offers.length;j++){
            setSecretSaleOfferOpen(offers[j],offers[j]===offer?willOpen:false);
          }
        });
      })(offers[oi]);
    }
    root.addEventListener('keydown',function(e){
      if(e.key!=='Escape')return;
      for(var k=0;k<offers.length;k++){setSecretSaleOfferOpen(offers[k],false);}
    });
    document.addEventListener('click',function(e){
      var t=e.target;
      if(t&&t.closest&&t.closest('[data-glc-ss-offer]'))return;
      for(var c=0;c<offers.length;c++){setSecretSaleOfferOpen(offers[c],false);}
    });
    window.addEventListener('resize',function(){
      for(var r=0;r<offers.length;r++){
        if(offers[r].querySelector('[aria-expanded="true"]'))positionSecretSaleOfferPanel(offers[r]);
      }
    });
  }
  initSecretSaleOffers();
  function initSliders(){
    if(window.innerWidth>960)return;
    var sliders=root.querySelectorAll('[data-glc-slider]');
    for(var si=0;si<sliders.length;si++){
      (function(sl){
        if(sl.dataset.glcSl){
          if(typeof sl._glcSync==='function'){sl._glcSync();}
          return;
        }
        sl.dataset.glcSl='1';
        var dots=sl.parentElement.querySelector('.glc-sdots');
        if(!dots)return;
        var ticking=false;
        function sync(){
          ticking=false;
          var w=sl.clientWidth||1;
          var idx=Math.round(sl.scrollLeft/w);
          if(idx<0)idx=0;
          var ds=dots.children;
          if(idx>ds.length-1)idx=ds.length-1;
          for(var m=0;m<ds.length;m++){ds[m].classList.toggle('on',m===idx);}
        }
        sl._glcSync=sync;
        sl.addEventListener('scroll',function(){
          if(ticking)return;ticking=true;
          requestAnimationFrame(sync);
        },{passive:true});
        if('onscrollend' in window){sl.addEventListener('scrollend',sync,{passive:true});}
        sl.addEventListener('touchend',function(){
          setTimeout(sync,120);setTimeout(sync,420);setTimeout(sync,750);
        },{passive:true});
        var dch=dots.children;
        for(var q=0;q<dch.length;q++){
          (function(qi){
            dch[qi].addEventListener('click',function(ev){
              ev.preventDefault();ev.stopPropagation();
              var w=sl.clientWidth||1;
              try{sl.scrollTo({left:qi*w,behavior:'smooth'});}catch(_e){sl.scrollLeft=qi*w;}
              setTimeout(sync,420);
            });
          })(q);
        }
        sync();
      })(sliders[si]);
    }
  }
  function syncAllSliders(){
    if(!document.documentElement.contains(root))return;
    initSliders();
    requestAnimationFrame(function(){
      var sliders=root.querySelectorAll('[data-glc-slider]');
      for(var i=0;i<sliders.length;i++){
        if(typeof sliders[i]._glcSync==='function'){sliders[i]._glcSync();}
      }
    });
  }
  var sliderSyncTimer=null;
  function queueSliderSync(){
    clearTimeout(sliderSyncTimer);
    syncAllSliders();
    sliderSyncTimer=setTimeout(syncAllSliders,250);
  }
  var sliderResizeTimer=null;
  window.addEventListener('resize',function(){
    clearTimeout(sliderResizeTimer);
    sliderResizeTimer=setTimeout(queueSliderSync,100);
  },{passive:true});
  window.addEventListener('pageshow',function(e){
    if(e.persisted){queueSliderSync();}
  });
  document.addEventListener('visibilitychange',function(){
    if(document.visibilityState==='visible'){queueSliderSync();}
  });
  document.addEventListener('shopify:section:load',function(e){
    if(e.target&&(e.target.contains(root)||root.contains(e.target))){queueSliderSync();}
  });
  queueSliderSync();
  syncVariantCards();
  var sectionId=root.dataset.sectionId;
  var filterCtl=null;
  function ajaxFilter(url,fallbackForm){
    var g=root.querySelector('.glc-grid');
    if(g)g.classList.add('glc-loading');
    if(filterCtl){try{filterCtl.abort();}catch(_e){}}
    filterCtl=('AbortController' in window)?new AbortController():null;
    var sep=url.indexOf('?')>-1?'&':'?';
    fetch(url+sep+'section_id='+encodeURIComponent(sectionId),{headers:{'Accept':'text/html'},signal:filterCtl?filterCtl.signal:undefined})
      .then(function(r){if(!r.ok)throw new Error('f');return r.text();})
      .then(function(html){
        var tmp=document.createElement('div');tmp.innerHTML=html;
        var nr=tmp.querySelector('#glc-'+sectionId)||tmp.querySelector('.glc');
        if(!nr)throw new Error('nr');
        root.innerHTML=nr.innerHTML;
        syncSecretSaleActivation();
        try{history.replaceState({},'',url);}catch(_e){}
        queueSliderSync();
        syncVariantCards();
        try{
          if(window.jdgm){
            if(typeof window.jdgm.customizeBadges==='function'){window.jdgm.customizeBadges();}
            if(typeof window.jdgm.batchRenderBadges==='function'){window.jdgm.batchRenderBadges();}
          }
        }catch(_e){}
        var y=root.getBoundingClientRect().top+(window.pageYOffset||0)-90;
        if((window.pageYOffset||0)>y){window.scrollTo(0,Math.max(0,y));}
      })
      .catch(function(err){if(err&&err.name==='AbortError'){return;}if(fallbackForm){fallbackForm.submit();}else{window.location=url;}});
  }
  function formUrl(f){
    var fd=new FormData(f);
    var qp=[];
    fd.forEach(function(v,k){if(v!==''&&v!=null){qp.push(encodeURIComponent(k)+'='+encodeURIComponent(v));}});
    var action=f.getAttribute('action')||window.location.pathname;
    return action+(qp.length?'?'+qp.join('&'):'');
  }
  function currentUrl(){
    try{return new URL(window.location.href);}catch(_e){return null;}
  }
  function goUrl(u,f){
    u.searchParams.delete('section_id');
    u.searchParams.delete('page');
    var q=u.searchParams.toString();
    ajaxFilter(u.pathname+(q?'?'+q:''),f);
  }
  root.addEventListener('change',function(e){
    var t=e.target;
    if(!t||!t.classList)return;
    var isVariant=t.matches&&t.matches('.glc-vdots input[type="radio"][name="id"]');
    if(isVariant){updateVariantCard(t,false);return;}
    var isChip=t.classList.contains('glc-chipbox');
    var isSort=(t.name==='sort_by'&&t.type==='radio');
    if(!isChip&&!isSort)return;
    var lb=t.closest?t.closest('.glc-chipbtn'):null;
    if(lb){if(t.checked){lb.classList.add('is-on');}else{lb.classList.remove('is-on');}}
    var f=t.closest('form');
    var u=currentUrl();
    if(!u){if(f){ajaxFilter(formUrl(f),f);}return;}
    if(isSort){
      u.searchParams.set('sort_by',t.value);
    }else{
      var vals=u.searchParams.getAll(t.name);
      u.searchParams.delete(t.name);
      for(var i=0;i<vals.length;i++){
        if(vals[i]!==t.value){u.searchParams.append(t.name,vals[i]);}
      }
      if(t.checked){u.searchParams.append(t.name,t.value);}
    }
    goUrl(u,f);
  });
  root.addEventListener('submit',function(e){
    var f=e.target;
    if(!(f&&f.classList&&f.classList.contains('glc-form')))return;
    e.preventDefault();
    var u=currentUrl();
    if(!u){ajaxFilter(formUrl(f),f);return;}
    var kill=[];
    u.searchParams.forEach(function(v,k){if(k==='sort_by'||k.indexOf('filter.')===0){kill.push(k);}});
    for(var i=0;i<kill.length;i++){u.searchParams.delete(kill[i]);}
    var fd=new FormData(f);
    fd.forEach(function(v,k){if(v!==''&&v!=null){u.searchParams.append(k,v);}});
    goUrl(u,f);
  });
  root.addEventListener('click',function(e){
    var a=e.target.closest?e.target.closest('.glc-chipbtn[href], .glc-chip[href], .glc-page[href]'):null;
    if(a&&a.getAttribute('href')){
      e.preventDefault();
      ajaxFilter(a.getAttribute('href'),null);
    }
  });
  if(!ajaxOn)return;
  function showAdded(btn){
    if(!btn)return;
    btn.classList.remove('glc-busy');
    btn.classList.add('glc-done');
    setTimeout(function(){btn.classList.remove('glc-done');},1600);
  }
  function updateCustomCartCount(cart){
    if(!cart||typeof cart.item_count!=='number')return;
    try{
      if(window.GlouraHeader&&typeof window.GlouraHeader.setCartCount==='function'){
        window.GlouraHeader.setCartCount(cart.item_count);
      }
    }catch(_e){}
  }
  function refreshThemeCart(){
    document.addEventListener('cart:updated',function(e){
      updateCustomCartCount(e&&e.detail?e.detail.cart:null);
    },{once:true});
    try{
      document.dispatchEvent(new CustomEvent('cart:refresh',{
        bubbles:true,
        detail:{open:true}
      }));
    }catch(_e){window.location=cartUrl;}
  }
  root.addEventListener('submit',function(e){
    var f=e.target;
    if(!f||!f.hasAttribute||!f.hasAttribute('data-glc-add'))return;
    e.preventDefault();
    if(f.dataset.glcSubmitting)return;
    f.dataset.glcSubmitting='1';
    var btn=f.querySelector('.glc-quick');
    if(btn){btn.classList.add('glc-busy');}
    var fd=new FormData(f);
    fetch(cartAddUrl+'.js',{method:'POST',body:fd,headers:{'Accept':'application/json'}})
      .then(function(r){if(!r.ok)throw new Error('add');return r.json();})
      .then(function(){
        delete f.dataset.glcSubmitting;
        showAdded(btn);
        refreshThemeCart();
      })
      .catch(function(){
        delete f.dataset.glcSubmitting;
        if(btn){btn.classList.remove('glc-busy');}
        try{f.submit();}catch(_e){window.location=cartUrl;}
      });
  });
  }
  function initAll(scope){
    if(!scope)return;
    if(scope.matches&&scope.matches('[data-glc-root]')){initGloura(scope);}
    if(!scope.querySelectorAll)return;
    var roots=scope.querySelectorAll('[data-glc-root]');
    for(var i=0;i<roots.length;i++){initGloura(roots[i]);}
  }
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',function(){initAll(document);},{once:true});
  }else{initAll(document);}
  document.addEventListener('shopify:section:load',function(e){initAll(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gloura-ueber-uns-neu"] && !Shopify.designMode) return;
  try {
    
(function(){
  if(window.__guAbout)return;window.__guAbout=true;
  function initSticky(root){
    var bar=root.querySelector('[data-gu-sticky]');
    if(!bar||!('IntersectionObserver' in window))return;
    var cta=root.querySelector('[data-gu-hero-cta]')||root.querySelector('.gu-hero');
    var end=root.querySelector('[data-gu-products]');
    var ctaOn=true,endOn=false;
    function draw(){var on=!ctaOn&&!endOn;bar.classList.toggle('is-on',on);document.documentElement.classList.toggle('gu-sticky-on',on);}
    var a=new IntersectionObserver(function(l){ctaOn=l[l.length-1].isIntersecting;draw();});
    a.observe(cta);
    /* Nach oben riesig erweitert: "im Bild oder schon vorbei" ist ein einziger Zustand, auch bei Sprüngen */
    var b=null;
    if(end){b=new IntersectionObserver(function(l){var e=l[l.length-1];endOn=e.isIntersecting||e.boundingClientRect.top<0;draw();},{rootMargin:'100000px 0px 0px 0px'});b.observe(end);}
    root.__guIo=[a,b];
  }
  function initAll(scope){
    var roots=scope.querySelectorAll?scope.querySelectorAll('[data-gu-root]'):[];
    for(var i=0;i<roots.length;i++){initSticky(roots[i]);}
  }
  function closeVideo(d){
    var slot=d.querySelector('[data-gu-slot]');
    if(d.open)d.close();
    slot.innerHTML='';
  }
  document.addEventListener('click',function(e){
    var t=e.target;if(!t||!t.closest)return;
    var open=t.closest('[data-gu-video]');
    if(open){
      var root=open.closest('[data-gu-root]');
      var d=root&&root.querySelector('[data-gu-dialog]');
      var tpl=open.querySelector('template');
      if(!d||!tpl||!d.showModal)return;
      e.preventDefault();
      var slot=d.querySelector('[data-gu-slot]');
      slot.innerHTML='';slot.appendChild(tpl.content.cloneNode(true));
      d.showModal();
      var v=slot.querySelector('video');
      if(v){v.setAttribute('preload','auto');var p=v.play();if(p&&p.catch)p.catch(function(){});}
      return;
    }
    if(t.closest('[data-gu-close]')){closeVideo(t.closest('[data-gu-dialog]'));return;}
    if(t.matches&&t.matches('[data-gu-dialog]')){closeVideo(t);}
  });
  document.addEventListener('close',function(e){
    if(e.target&&e.target.matches&&e.target.matches('[data-gu-dialog]')){e.target.querySelector('[data-gu-slot]').innerHTML='';}
  },true);
  document.addEventListener('submit',function(e){
    var f=e.target;
    if(!f||!f.matches||!f.matches('form[data-gu-add]'))return;
    e.preventDefault();
    if(f.dataset.guBusy)return;
    f.dataset.guBusy='1';
    var b=f.querySelector('button');
    if(b)b.classList.add('is-busy');
    fetch(f.getAttribute('action')+'.js',{method:'POST',body:new FormData(f),headers:{'Accept':'application/json'}})
      .then(function(r){if(!r.ok)throw new Error('add');return r.json();})
      .then(function(){
        delete f.dataset.guBusy;
        if(b){b.classList.remove('is-busy');b.classList.add('is-done');setTimeout(function(){b.classList.remove('is-done');},1600);}
        document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true,detail:{open:true}}));
        fetch(f.getAttribute('action').replace(/\/add$/,'')+'.js',{headers:{'Accept':'application/json'}})
          .then(function(r){return r.json();})
          .then(function(c){if(window.GlouraHeader&&window.GlouraHeader.setCartCount)window.GlouraHeader.setCartCount(c.item_count);})
          .catch(function(){});
      })
      .catch(function(){
        delete f.dataset.guBusy;
        if(b)b.classList.remove('is-busy');
        f.submit();
      });
  });
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){initAll(document);},{once:true});}else{initAll(document);}
  document.addEventListener('shopify:section:load',function(e){initAll(e.target);});
  document.addEventListener('shopify:section:unload',function(e){
    var r=e.target.querySelector&&e.target.querySelector('[data-gu-root]');
    if(r&&r.__guIo){r.__guIo.forEach(function(o){if(o)o.disconnect();});document.documentElement.classList.remove('gu-sticky-on');}
  });
})();

  } catch(e) { console.error(e); }
})();
})();
